import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "microsoft-entra",
  "name": "Microsoft Entra ID",
  "category": "integrations",
  "description": "Interact with Microsoft Entra ID (Azure AD) via Microsoft Graph API - look up users, groups, and directory information",
  "icon": "microsoft-entra",
  "iconType": "microsoft-icon",
  "color": "blue",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Microsoft Entra ID",
    "color": "#0078D4"
  },
  "credentials": [
    {
      "name": "microsoft_entra_oauth",
      "required": false,
      "displayName": "Microsoft Entra ID OAuth2",
      "displayOptions": {
        "show": {
          "useCredential": [true]
        }
      }
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "microsoft",
    "entra",
    "azure-ad",
    "directory",
    "users",
    "groups",
    "identity"
  ],
  "comingSoon": false
};

export default definition;
